var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"md-grid-cell-selection",attrs:{"role":"columnheader"}},[_c('div',{staticClass:"md-grid-cell-inner"},[_c('bs-checkbox',{attrs:{"color":_vm.color,"model":_vm.allSelected},on:{"change":_vm._onChange}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }